import * as React from "react";
const SvgItems = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#082B60"
      d="m25.184 8.15-10.787 6.247c-.434.252-.98.252-1.429 0L2.182 8.149c-.77-.448-.966-1.499-.378-2.157.406-.462.868-.84 1.359-1.107L10.755.683c1.625-.91 4.259-.91 5.884 0l7.592 4.202c.49.266.952.659 1.359 1.107.56.658.364 1.709-.407 2.157M12.888 16.999v9.553c0 1.065-1.08 1.765-2.032 1.303-2.885-1.415-7.746-4.062-7.746-4.062C1.4 22.826 0 20.389 0 18.386v-7.228C0 10.05 1.163 9.35 2.115 9.897l10.072 5.841c.42.266.7.742.7 1.26M14.484 16.999v9.553c0 1.065 1.079 1.765 2.031 1.303 2.886-1.415 7.747-4.062 7.747-4.062 1.709-.967 3.11-3.404 3.11-5.407v-7.228c0-1.107-1.163-1.808-2.116-1.261l-10.071 5.841c-.42.266-.7.742-.7 1.26"
    />
  </svg>
);
export default SvgItems;
